<template>
  <div class="clients-page">
    <app-page-header title="Usuários">
      <button
        @click="exportClients()"
        :disabled="isExportingAll"
        v-app-button.icon-left
      >
        <b-icon size="is-small" icon="download"></b-icon>USUÁRIOS
      </button>
      <button
        @click="exportNewClients()"
        :disabled="isExportingNewUsers"
        v-app-button.icon-left
      >
        <b-icon size="is-small" icon="download"></b-icon>USUÁRIOS NOVOS
      </button>
      <button @click="importClient()" v-app-button.icon-left>
        <b-icon size="is-small" icon="upload"></b-icon>IMPORTAR USUÁRIOS
      </button>
      <button @click="importCards()" v-app-button.icon-left>
        <b-icon size="is-small" icon="upload"></b-icon>IMPORTAR CARTÕES
      </button>
      <router-link
        :to="{ name: 'clients.create' }"
        tag="button"
        v-app-button.icon-left
      >
        <b-icon size="is-small" icon="plus" />Novo
      </router-link>
    </app-page-header>

    <clients-table ref="clientsTable"></clients-table>

    <b-modal
      :active.sync="showModal"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <client-import-modal @success="onImportSuccess"></client-import-modal>
    </b-modal>
  </div>
</template>

<script>
import ClientService from '@/services/client.service';
import ClientsTable from '@/components/Tables/ClientsTable.vue';
import ClientCardImportModal from '@/components/Modals/ClientCardImportModal.vue';
import ClientImportModal from '@/components/Modals/ClientImportModal.vue';

export default {
  name: 'clients-page',
  components: {
    ClientsTable,
    ClientImportModal,
  },
  data: () => {
    return {
      showModal: false,
      isExportingAll: false,
      isExportingNewUsers: false,
    };
  },
  methods: {
    importClient() {
      this.showModal = true;
    },
    importCards() {
      this.$buefy.modal.open({
        parent: this,
        component: ClientCardImportModal,
        trapFocus: true,
        hasModalCard: true,
      });
    },
    exportClients() {
      this.isExportingAll = true;
      const filters = this.$refs.clientsTable.requestFilters;

      ClientService.export(filters)
        .then(({ data }) => {
          const link = document.createElement('a');
          link.target = '_blank';
          link.href = data.url;
          link.click();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao realizar exportação.',
            'error'
          );
        })
        .finally(() => (this.isExportingAll = false));
    },
    exportNewClients() {
      this.isExportingNewUsers = true;

      ClientService.exportNewClients()
        .then(({ data }) => {
          const link = document.createElement('a');
          link.target = '_blank';
          link.href = data.url;
          link.click();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao realizar exportação.',
            'error'
          );
        })
        .finally(() => (this.isExportingNewUsers = false));
    },
    onImportSuccess() {
      this.$refs.clientsTable.load();
    },
  },
};
</script>
